<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title.user_name}}</span>
        ” 的 “
        <span style="color:red">{{title.pro_name}}</span>
        ” 手术项目救助拨款申请信息
        <div style="float:right;">
          <i class="el-icon-question"></i>如何填写？
          <a
            href="javascript:;"
            style="color:#b60205;text-decoration:underline"
            @click="helpMe"
          >查看示意图</a>
        </div>
      </div>

      <el-dialog :visible.sync="help_show" width="80%" append-to-body title="众筹手术项目救助拨款申请示意图">
        <img width="100%" src="../../../../assets/images/cfpro_pay_help1.png" alt />
      </el-dialog>
      <el-form
        :model="applyForm"
        :inline="true"
        :rules="rules1"
        ref="formRef"
        label-width="120px"
        style="margin-bottom:80px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目负责人" prop="leader">
              <el-input v-model="applyForm.leader" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="负责人电话" prop="leader_tel">
              <el-input v-model="applyForm.leader_tel" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="收款单位名称" prop="payee_unit_name">
              <el-input v-model="applyForm.payee_unit_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医保结算日期">
              <el-date-picker
                style="width:85%"
                v-model="applyForm.ybjssj"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="请选择医保结算日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="开户行" prop="bank_name">
              <el-input v-model="applyForm.bank_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开户名" prop="account_name">
              <el-input v-model="applyForm.account_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="银行卡号" prop="account_number">
              <el-input v-model="applyForm.account_number" :maxlength="25"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="font-size:16px;margin-bottom:20px;margin-left:20px">相关费用</div>

        <el-row>
          <el-col :span="12">
            <el-form-item label="治疗总费用" prop="zlzfy">
              <!-- <el-input v-model.number="applyForm.zlzfy" maxlength="9"></el-input> -->
              <el-input-number
                v-model="applyForm.zlzfy"
                controls-position="right"
                :min="0"
                :precision="2"
                :max="99999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="基金会救助额" prop="apply_money">
              <el-input-number
                v-model="applyForm.apply_money"
                controls-position="right"
                :min="0"
                :precision="2"
                :max="Number(applyForm.approve_amount)"
                style="width:200px"
              ></el-input-number>
              <el-tooltip
                class="item"
                effect="dark"
                :content="'原申请金额：'+applyForm.apply_amount+ '元；基金会审批金额为：'+applyForm.approve_amount+'元'"
                placement="top"
              >
                <i class="el-icon-info" style="cursor:pointer;"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="医保报销金额" prop="ybbxje">
              <el-input-number
                v-model="applyForm.ybbxje"
                controls-position="right"
                :min="0"
                :precision="2"
                :max="99999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="其它金额">
              <!-- <el-input
                v-model.number="other_amount"
                disabled
                placehoder="会自动计算得出结果"
                style="width:200px"
              ></el-input>-->
              <el-input-number
                v-model="other_amount"
                controls-position="right"
                :precision="2"
                :max="99999999"
              ></el-input-number>
              <el-tooltip effect="dark" content="计算规则：其它金额 = 治疗总费用-基金会救助金额-医保报销金额" placement="top">
                <i class="el-icon-info" style="cursor:pointer;"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="其它金额备注" prop="remarks">
              <el-input
                v-model.number="applyForm.remarks"
                placeholder="请简述下其它金额包含类型"
                type="textarea"
                :rows="2"
                style="width:500px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="font-size:16px;margin-bottom:20px;margin-left:20px">相关附件</div>

        <el-row>
          <el-col>
            <el-form-item label="手术照片" required>
              <el-upload
                ref="uploadRef"
                :action="uploadFileUrl"
                :file-list="defFiles1"
                :before-upload="beforeUploadFile"
                :on-success="uploadSuccess1"
                :on-remove="uploadDel1"
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传压缩文件</el-button>
              </el-upload>
              <div class="el-icon-info">
                请上传格式为rar或zip的文件，
                <span style="color:red">术前、术中、术后照片请分类打包上传</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-dialog :visible.sync="show_pic" title="手术项目拨款申请上传压缩文件要求" append-to-body>
          <viewer :images="['../../../../assets/images/cfpro_payout_apply.png']">
            <img width="100%" src="../../../../assets/images/cfpro_payout_apply.png" alt />
          </viewer>
        </el-dialog>

        <el-row v-for="(item,index) in filesList" :key="'files'+index">
          <el-col>
            <el-form-item :label="item.text" style="width:80%" required>
              <el-upload
                :ref="'uploadFileRef2'+index"
                :action="uploadFileUrl"
                :file-list="defFiles2[index]"
                :before-upload="beforeUploadFile"
                :on-success="(response, file, fileList) =>{
                  handlerUpload(fileList,index);
                }"
                :on-remove="(file, fileList) =>{
                  handlerUpload(fileList,index);
                }"
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传压缩文件</el-button>
              </el-upload>
              <div class="el-icon-info">
                请上传格式为rar或zip的文件，
                <span
                  style="color:red;text-decoration:underline;cursor:pointer;"
                  @click="showPic"
                >点击查看压缩文件要求</span>
                <br />
              </div>
              <p>
                <span style="color:red">注</span>：需要邮寄到基金会结算的资料包括所有法律文书原件，救助申请表，
                <br />诊断证明，户口本/身份证，贫困证件，患者故事，费用组成表，医疗发票，
                <br />出院证明，费用清单（涉及医保报销的还需要提供医保回执单）
              </p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="备注" prop="apply_remark">
              <el-input
                v-model.number="applyForm.apply_remark"
                type="textarea"
                :rows="3"
                style="width:500px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="demo-drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-check"
          @click="submitBtn"
          :loading="loading"
        >提交</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: Object,
      default: () => {}
    },
    size: {
      type: [String, Number],
      default: "85%"
    },
    id: {
      type: [String, Number],
      default: null
    },
    pid: {
      type: Number,
      default: null
    },
    aid: {
      type: Number,
      default: null
    },
    pay_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      help_show: false, //查看示意图
      visible: false,
      loading: false,
      uploadFileUrl: null,

      show_pic: false, //查看示意图片

      filesList: [], //明细化附件集

      defFiles1: [], //编辑页面图片集
      defFiles2: [], //手术

      applyForm: {
        apply_money: null,
        apply_amount: null, //救助申请金额用于展示
        operation_files: [], //手术照片压缩文件
        zlzfy: null,
        zfje: null, //其它金额
        apply_money: null,
        apply_remark: null
      },

      rules1: {
        // apply_user_name: [
        //   { required: true, message: "请输入申请人姓名", trigger: "blur" }
        // ],
        payee_unit_name: [
          { required: true, message: "请输入收款单位名称", trigger: "blur" }
        ],
        // payee_rela_user_name: [
        //   { required: true, message: "请输入单位联系人", trigger: "blur" }
        // ],
        // payee_office_phone: [
        //   { required: true, message: "请输入单位联系座机", trigger: "blur" }
        // ],
        // payee_telephone: [
        //   { required: true, message: "请输入单位手机号码", trigger: "blur" },
        //   { validator: checkPhone, trigger: "blur" }
        // ],
        bank_name: [
          { required: true, message: "请输入收款开户行", trigger: "blur" }
        ],
        account_name: [
          { required: true, message: "请输入收款开户名", trigger: "blur" }
        ],
        account_number: [
          { required: true, message: "请输入收款银行卡号", trigger: "blur" }
        ],

        // costs: [
        //   {
        //     required: true,
        //     type: "array",
        //     message: "请添加费用组成单",
        //     trigger: "change"
        //   },

        //   { validator: checkCosts, trigger: "change" }
        // ],

        // payment_reason: [
        //   { required: true, message: "请输入申请理由", trigger: "blur" }
        // ],
        apply_money: [
          { required: true, message: "基金会救助金额不能为空", trigger: "blur" }
        ],
        // reg_time:[
        //     { required: true, message: '登记时间不能为空', trigger: 'change' },
        // ],
        zlzfy: [
          { required: true, message: "治疗总费用不能为空", trigger: "blur" }
        ],
        // xmzzje: [
        //   { required: true, message: "项目资助金额不能为空", trigger: "blur" }
        // ],
        // zfje: [
        //   { required: true, message: "自费金额不能为空", trigger: "blur" }
        // ],
        jjbze: [
          { required: true, message: "基金救助额不能为空", trigger: "blur" }
        ],
        ybbxje: [
          { required: true, message: "医保报销金额不能为空", trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    other_amount: {
      get: function() {
        let num = 0;

        if (
          this.applyForm.zlzfy >= 0 &&
          this.applyForm.ybbxje >= 0 &&
          this.applyForm.apply_money >= 0
        ) {
          num = this.Subtr(
            this.Subtr(this.applyForm.zlzfy, this.applyForm.ybbxje),
            this.applyForm.apply_money
          );
          return num;
        }
      }
    }
  },

  methods: {
    //示意图操作
    helpMe() {
      this.help_show = true;
    },

    //减法精度丢失问题
    Subtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },

    handlerUpload(fileList, index) {
      this.$set(this.defFiles2, index, []);
      this.$set(this.defFiles2, index, fileList);
    },

    cancelBtn() {
      this.visible = false;
    },

    // //计算表格合计
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     if (index === 0) {
    //       sums[index] = "合计";
    //       return;
    //     }

    //     if (index === 4 || index == 1 || index == 2) {
    //       return "";
    //     }

    //     const values = data.map(item => Number(item[column.property]));
    //     if (!values.every(value => isNaN(value))) {
    //       sums[index] = values.reduce((prev, curr) => {
    //         const value = Number(curr);
    //         if (!isNaN(value)) {
    //           return prev + curr;
    //         } else {
    //           return prev;
    //         }
    //       }, 0);
    //     } else {
    //       sums[index] = "N/A";
    //     }
    //   });

    //   if (sums[3] > 0) {
    //     sums[3] = "总额：" + this.setMoneyFormat(sums[3]) + " 元";
    //   }

    //   // if (sums[1] > 0) {
    //   //   sums[1] = "平均值：" + sums[1] / data.length;
    //   // }
    //   // if (sums[2] > 0) {
    //   //   sums[2] = "总数：" + this.setMoneyFormat(sums[2]);
    //   // }

    //   return sums;
    // },

    // //千分化金额
    // setMoneyFormat(num) {
    //   if (num) {
    //     let value = typeof num === "number" ? num : Number(num);
    //     return (value.toFixed(2) + "").replace(
    //       /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
    //       "$&,"
    //     );
    //   }
    // },

    // //费用组成单 增加列
    // addRow() {
    //   let temp = {
    //     cost_item_name: null,
    //     unit_price: null,
    //     number: null,
    //     total: null
    //   };

    //   let len = this.applyForm.costs.length;
    //   if (len > 0) {
    //     let info = this.applyForm.costs[len - 1];
    //     if (
    //       !(
    //         info.cost_item_name &&
    //         info.unit_price > 0 &&
    //         info.number > 0 &&
    //         info.total
    //       )
    //     ) {
    //       return this.$message.warning("请先完善上一行费用组成单信息！");
    //     }
    //   }

    //   this.applyForm.costs.push(temp);
    // },

    // //费用组成单 删除列
    // delRow(index, row) {
    //   this.applyForm.costs.splice(index, 1);
    // },

    //预览图片
    showPic() {
      this.show_pic = true;
    },

    //获取附件集 手术项目
    getFilesList() {
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 200602,
          table: "pub_dict"
        })
        .then(res => {
          if (res && res.code == 200) {
            this.filesList = res.data;
          }
        });
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    // 手术照片上传成功
    uploadSuccess1(response, file, fileList) {
      this.defFiles1 = fileList;
    },

    uploadDel1(file, fileList) {
      this.defFiles1 = fileList;
    },

    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file, ["zip", "rar"]);
      return bool;
    },

    // // 手术照片上传成功
    // uploadSuccess2(response, file, fileList){
    //   this.operation_files = fileList;
    // },

    //获取上一次项目救助数据
    getLastInfo() {
      this.$db
        .post(this.$db.config.getcfProLastPayApplyInfo, { apply_id: this.id })
        .then(res => {
          if (res && res.code == 200) {
            this.applyForm = res.data;
          }
        });
    },

    //获取编辑数据
    getEditInfo(id, pid) {
      this.$db
        .post(this.$db.config.getCfProPayApplyInfo, { id: id, project_id: pid })
        .then(res => {
          if (res && res.code == 200) {
            this.applyForm = res.data;
            let arr = [];
            let arr1 = [];
            res.data.files_details.forEach((item, key) => {
              arr[key] = item.files_path;
            });

            this.defFiles2 = arr;
            this.defFiles1 = res.data.operation_files_path;
          }
        });
    },

    //提交拨款申请
    submitBtn() {
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          let arr1 = [];

          this.applyForm.project_apply_id = this.aid;

          if (this.defFiles1 && this.defFiles1.length > 0) {
            for (const item of this.defFiles1) {
              if (item.hasOwnProperty("response")) {
                arr1.push(item.response.data.id);
              } else {
                arr1.push(item.id);
              }
            }
            this.applyForm.operation_files = arr1;
          } else {
            this.$message.warning("请上传手术照片压缩文件！");
            return;
          }

          //处理批量附件集
          let arr = [];
          for (const [key, val] of this.filesList.entries()) {
            let temp = { dict_id: val.value, files_id: [] };
            if (this.defFiles2[key] && this.defFiles2[key].length > 0) {
              for (const item of this.defFiles2[key]) {
                if (item.hasOwnProperty("response")) {
                  temp.files_id.push(item.response.data.id);
                } else {
                  temp.files_id.push(item.id);
                }
              }
              arr.push(temp);
              this.applyForm.payment_files = arr;
            } else {
              this.$message.warning(val.text + "不能为空！");
              return;
            }
          }

          if (Number(this.other_amount) >= 0) {
            this.applyForm.zfje = Number(this.other_amount);
          } else {
            return this.$message.warning("其它金额不能小于0");
          }

          this.$confirm(
            "寄出结算资料前请仔细核对一下发票金额，费用清单，费用组成表消费总额是否一致",
            "提交需知",
            {
              confirmButtonText: "我知道了",
              cancelButtonText: "再看看",
              type: "warning"
            }
          ).then(() => {
            this.applyForm.apply_id = this.id;

            this.loading = true;
            let url;

            if (this.pay_id > 0) {
              url = this.$db.config.updateCfProPayApplyInfo;
            } else {
              url = this.$db.config.submitCfProPayApplyInfo;
            }

            this.$db.post(url, this.applyForm).then(res => {
              this.loading = false;
              if (res && res.code == 200) {
                this.$message.success(res.msg);
                this.cancelBtn();
                this.$emit("success", "1");
              }
            });
          });
        } else {
          return this.$message.error("请填写完整信息！");
        }
      });
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  created() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.getFilesList();

    this.applyForm.project_id = this.pid;

    if (this.pay_id > 0) {
      //判断是否编辑
      this.getEditInfo(this.pay_id, this.pid);
    } else {
      this.getLastInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 85%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/appropriation/info1.vue